import TextAndImageSection from "../../componets/TextAndImageSection";

export default function Section6() {
  return (
    <TextAndImageSection
      sectionName="Section6"
      containerName="section6"
      title="Enhance Your Digital Experience with Exceptional Design"
      text="Ready to create a digital experience that delights your users and drives business growth? Contact Us today to discuss your project and discover how our UI/UX design services can elevate your digital presence."
      imgUrl="assets/world-ui-ux-design.jpg"
      dividerMargin=" mt-[1%] md:mt-[5%]"
      btnLink="https://mean3.com/contact-mean3/"
    />
  );
}
